var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#9D9D9C;stroke-width:47.0588;stroke-miterlimit:94.1176;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#575757;stroke:#9D9D9C;stroke-miterlimit:10;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#9D9D9C;stroke:#9D9D9C;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.6,46.9c0-12.9,10.6-23.4,23.4-23.4h400.2c12.9,0,31.5,6.5,41.8,14.7l80.9,64.7 c10.1,8.1,18.4,25.1,18.4,38.2V753c0,12.9-10.5,23.5-23.5,23.5H141.2c-13,0-23.5-10.6-23.5-23.4L117.6,46.9L117.6,46.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.3,282.4h329.4v23.5H235.3V282.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.3,352.9h329.4v23.5H235.3V352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.3,423.5h329.4V447H235.3V423.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.3,494.1h141.2v23.5H235.3V494.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M517.6,47.1h23.5v141.2h-23.5V47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M517.6,164.7h141.2v23.5H517.6V164.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.5bb1013ccb158b5dd378f0c137839c09.svg";
export { ForwardRef as ReactComponent };